// Copyright 1999-2024. WebPros International GmbH. All rights reserved.

import styled from 'styled-components';

export const SubInputs = styled.div`
  margin-top: -15px;
  margin-left: 30px;
  margin-bottom: 10px;
`;